// extracted by mini-css-extract-plugin
export default {"container":"_2z_7LarS","pageChangeButton":"ZtNpz1d0","pageDisplayContainer":"_1i2ZYFmd","pageDisplayNumber":"_2SGXUpGH"};